const Publications = () => {
  return (
    <div className="container min-h-screen flex flex-col items-center justify-center mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold">
        Bienvenue sur la page de rapports et publications
      </h1>
      <p className="text-lg">
        Pas de rapports et publications pour le moment, mais bientôt !
      </p>
    </div>
  );
};

export default Publications;
